import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

const ContexBox = ({onModal}) => {
    return (
        <Box className="Moda-from-Software-contact">
            <div className="Moda-from-SoftwareTitle">
                <h1>Contacto</h1>
            </div>
            <div>
                <Link
                    href="https://wa.link/kajmsmhttps://wa.me/584146541501?text=%C2%A1Hola!%20Muchas%20gracias%20por%20ponerte%20en%20contacto%20con%20nosotros.%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%20hoy?"
                    variant="body2"
                >
                    <h2>WhatsApp: +58 414 654 1501</h2>
                </Link>
            </div>
            <div>
                <Link
                    href="mailto:superpoolhipico@gmail.com"
                    variant="body2"
                >
                    <h2>Email: superpoolhipico@gmail.com </h2>
                </Link>
            </div>
            <div className="Moda-from-Buttom">
                <Button
                    onClick={() => onModal(false)}
                    variant="contained"
                    color="primary"
                >
                    Salir
                </Button>
            </div>
        </Box>
    )
}
 
export default ContexBox;